import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/ui/Button"
import { Chip } from "@components/ui/Chip"
import { Input } from "@components/ui/Input"
import { TabControl } from "@components/ui/TabControl"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks, useInlineEditableValue } from "eddev/blocks"
import { useState } from "react"
import { useDonateCampaignContext } from "./donate-campaign"

export const meta: BlockMeta = {
  title: "Donation Card",
  description: "An item for donation",
}

export default defineBlock("tickets/donate-campaign-item", (props) => {
  const [chip1, setChip1] = useInlineEditableValue("chip1", "Example text")
  const [chip2, setChip2] = useInlineEditableValue("chip2", "Example text")
  const showChip1 = env.admin || (chip1.trim() !== "" && chip1 !== "Example text")
  const showChip2 = env.admin || (chip2.trim() !== "" && chip2 !== "Example text")
  const showChips = showChip1 || showChip2
  const [thisAmount, setThisAmount] = useInlineEditableValue("title", "$0")
  const thisAmountNumber = props.type === "custom" ? "custom" : parseFloat(thisAmount.replace(/[^0-9.]/g, ""))
  const {
    amount,
    setAmount,
    customAmount,
    setCustomAmount,
    ferveItemHash,
    setFerveItemHash,
    fervePriceTypeHash,
    setFervePriceTypeHash,
  } = useDonateCampaignContext()
  const selected =
    amount === thisAmountNumber ||
    (ferveItemHash === props.ferveItemHash && fervePriceTypeHash === props.fervePriceTypeHash)

  const selectItem = () => {
    if (props.ferveItemHash && props.fervePriceTypeHash) {
      setAmount(undefined)
      setCustomAmount(0)
      setFerveItemHash(props.ferveItemHash)
      setFervePriceTypeHash(props.fervePriceTypeHash)
    } else {
      setAmount(thisAmountNumber)
      setFerveItemHash(undefined)
      setFervePriceTypeHash(undefined)
    }
  }

  return (
    <div
      className={cn(
        "bg-bg p-5 rounded-md flex flex-col gap-5 w-full border border-bg transition-all cursor-pointer hover:border-black",
        props.type === "custom" && "md:col-span-2",
        selected ? "theme-dark" : "theme-light",
      )}
      onClick={() => selectItem()}
    >
      <div className={cn("grid grid-cols-1 gap-5", props.type === "custom" && "md:grid-cols-2")}>
        <div className="flex flex-col gap-5">
          <div className="flex justify-between">
            <div className="flex flex-col gap-5">
              {showChips && (
                <div className="flex gap-2 items-center flex-wrap">
                  {showChip1 && (
                    <Chip variant="hero">
                      <EditableText as="span" store="chip1" placeholder="Example text" />
                    </Chip>
                  )}
                  {showChip2 && (
                    <Chip variant="outline">
                      <EditableText as="span" store="chip2" placeholder="Example text" />
                    </Chip>
                  )}
                </div>
              )}
              <EditableText
                as="h3"
                store="title"
                placeholder="$0"
                defaultValue="$0"
                className="type-title-l text-fg transition-colors"
              />
            </div>
            <div className="flex justify-end">
              {props.image && props.type !== "custom" ? (
                <ResponsiveImage {...props.image} className="rounded-sm h-10 aspect-video flex overflow-hidden" />
              ) : env.admin && props.type !== "custom" ? (
                <div className="aspect-video h-10 bg-neutral-300 rounded-sm flex justify-center items-center">
                  IMAGE
                </div>
              ) : null}
            </div>
          </div>
          <div className="flex flex-col [&_>_div_>_p:first-child]:mt-0 [&_>_div_>_p:last-child]:mb-0">
            <InnerBlocks
              allowedBlocks={["core/paragraph"]}
              defaultBlocks={[
                [
                  "core/paragraph",
                  {
                    placeholder:
                      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                  },
                ],
              ]}
            />
          </div>
          {props.button?.url && (
            <Button
              variant="default"
              className="w-full justify-between"
              rightIcon={props.button.icon || "chevronRight"}
              href={props.button.url}
              target={props.button.target}
            >
              {props.button.title}
            </Button>
          )}
        </div>
        {props.type === "custom" && (
          <div className="self-end flex flex-col gap-3">
            <EditableText
              as="p"
              store="custom-text"
              placeholder="Other amount (All donations are in Australian dollars)"
              defaultValue="Other amount (All donations are in Australian dollars)"
              className="type-label-caps text-fg-secondary"
            />
            <Input
              type="number"
              placeholder="Enter amount"
              className="w-full [&_>_input]:!border-none [&_>_input]:!appearance-none [&_>_input]:!shadow-none [&_>_input]:!outline-none"
              leftIcon="money"
              onClick={(e) => {}}
              onChange={(e) => {
                const value = e.currentTarget.value.replace(/[^0-9.]/g, "")
                if (value === "") {
                  setCustomAmount(0)
                } else {
                  setCustomAmount(parseFloat(value))
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
})
